// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/wooden-table-texture.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./images/semapCont2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#time-zones-world-map {
    text-align: center;
    font-family: "Georgia", serif;
    background-color: #f5f5dc;
    min-height: 100hv;
    /* background-image: url('./images/wooden-table-texture.jpg'); */
    background: linear-gradient(to top, rgba(18, 24, 39, 1), rgba(18, 24, 39, 0) 30%),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    padding: 0;
    margin: 0;
  }

  .TZTitle {
    font-size: 54px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: #61aea2;
    text-shadow: 
      2px 2px 0px #013243, /* Dark shadow for depth */
      4px 4px 0px #028484, /* Mid-tone shadow for gradient effect */
      6px 6px 2px rgba(0, 0, 0, 0.2); /* Light shadow for soft finish */
    font-weight: bold;
    perspective: 100px;
    transform: translateZ(5px);
  }
  

  .mapbg {
    width: 90%;
    height: 80vh;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    padding: 0;
  }
  
  .map-container {
    width: 100%;
    height: 80vh;
    opacity: 0.7;
    filter: grayscale(70%);
    mask-image: radial-gradient(circle, rgba(0, 0, 0, 1) 30%, rgba(0, 0, 0, 0) 90%);
    -webkit-mask-image: radial-gradient(circle, rgba(0, 0, 0, 1) 30%, rgba(0, 0, 0, 0) 90%);
  }

  .map-label {
    background-color: rgba(255, 255, 255, 0.9);
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 5px;
    font-size: 12px;
    line-height: 1.2;
    white-space: nowrap;
    text-align: center;
    transform: translate(-50%, -120%);
    pointer-events: none;
  }
  
  @media (max-width: 768px){
    .mapbg{
        width: 100%;
        padding: 65px 0px;
    }

    #time-zones-world-map{
      padding: 0px 18px;
    }
    
  }

.TZcard {
	color: #013243;
	width: 300px;
	height: 400px;
  margin-bottom: 0;
	background: #e0e1dc;
	transform-style: preserve-3d;
	transform: translate(-190%,-80%) perspective(1000px)rotate(-25deg);
	box-shadow: inset 300px 0 50px rgba(0,0,0,.5), 20px 0 60px rgba(0,0,0,.5);
	transition: 1.5s;
}

.TZcard:hover {
	transform: translate(-50%,-97%) perspective(2000px) rotate(15deg) scale(1.2);
	box-shadow: inset 20px 0 50px rgba(0,0,0,.5), 0 10px 100px rgba(0,0,0,.5);
}

.TZcard:before {
	content:'';
	width: 100%;
	height: 5px;
	background: #BAC1BA;
	transform-origin: bottom;
	transform: skewX(-45deg);
}

.TZcard:after {
	content: '';
	width: 5px;
	height: 100%;
	background: #92A29C;
	transform-origin: left;
	transform: skewY(-45deg);
}

.TZcard .TZimgBox {
	width: 100%;
	height: 100%;
	position: relative;
	transform-origin: left;
	transition: .7s;
}

.TZcard .TZbark {
	position: absolute;
	background: #e0e1dc;
	width: 100%;
	height: 100%;
	opacity: 0;
	transition: .7s;
}

.TZcard .TZimgBox img {
	min-width: 250px;
	max-height: 400px;
}

.TZcard:hover .TZimgBox {
	transform: rotateY(-135deg);
}

.TZcard:hover .TZbark {
	opacity: 1;
	transition: .6s;
    box-shadow: 300px 200px 100px rgba(0, 0, 0, .4) inset;
}

.TZcard .TZdetails {
	position: absolute;
	top: -30px;
	left: 25px;
	box-sizing: border-box;
	padding: 0 0 0 10px;
	z-index: -1;
	margin-top: 70px;
  text-align: center;
  align-items: center;
}

.TZcard .TZdetails p {
	font-size: 14px;
	line-height: 1.5;
}

.TZcard .TZdetails h4 {
    font-size: 20px;
	text-align: center;
}

@media (max-width: 1335px) {
    .TZcard {
      transform: translate(-105%, -70%) perspective(1000px) rotate(-20deg);
      margin: 10px auto;
      height: auto;
      z-index: 99;
    }
    .TZcard .TZdetails {
        margin-top: 0;
        padding: 20px;
      }
      .TZcard:hover {
        transform: translate(0,-50%) perspective(2000px) rotate(0deg) scale(1.2);
        box-shadow: inset 20px 0 50px rgba(0,0,0,.5), 0 10px 100px rgba(0,0,0,.5);
      }
      .TZcard .TZdetails{
        top: -5px;
      }
  }

@media (max-width: 768px) {
    .TZcard {
      transform: translate(0%, -35%) perspective(1000px) rotate(0deg);
      margin: 20px auto;
      height: auto;
    }
    .TZcard .TZdetails {
        margin-top: 0;
        padding: 20px;
      }
      .TZcard .TZdetails p {
        line-height: 1.8;
        font-size: 14px;
        transform: rotate(0deg);
      }
      .TZcard:hover {
        transform: translate(0,-35%) perspective(2000px) rotate(0deg) scale(1.2);
        box-shadow: inset 20px 0 50px rgba(0,0,0,.5), 0 10px 100px rgba(0,0,0,.5);
      }
  }

  .decorate-image {
    position: absolute;
    right:0;
    width: 20%;
    min-width: 200px;
    max-width: 350px;
    height: auto;
    z-index: 10;
    transform: translate(-50%, -80%)
  }

  @media (max-width: 1335px) {
    .decorate-image{
      transform: translate(-20%, -80%)
    }
  }

  @media (max-width: 768px) {
    .decorate-image{
      display: none;
    }
  }`, "",{"version":3,"sources":["webpack://./src/App/TimeZonesWorldMap.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,yBAAyB;IACzB,iBAAiB;IACjB,gEAAgE;IAChE;2CACwC;IACxC,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,UAAU;IACV,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd;;;oCAGgC,EAAE,iCAAiC;IACnE,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;EAC5B;;;EAGA;IACE,UAAU;IACV,YAAY;IACZ,yDAAgD;IAChD,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,+EAA+E;IAC/E,uFAAuF;EACzF;;EAEA;IACE,0CAA0C;IAC1C,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,iCAAiC;IACjC,oBAAoB;EACtB;;EAEA;IACE;QACI,WAAW;QACX,iBAAiB;IACrB;;IAEA;MACE,iBAAiB;IACnB;;EAEF;;AAEF;CACC,cAAc;CACd,YAAY;CACZ,aAAa;EACZ,gBAAgB;CACjB,mBAAmB;CACnB,4BAA4B;CAC5B,kEAAkE;CAClE,yEAAyE;CACzE,gBAAgB;AACjB;;AAEA;CACC,4EAA4E;CAC5E,yEAAyE;AAC1E;;AAEA;CACC,UAAU;CACV,WAAW;CACX,WAAW;CACX,mBAAmB;CACnB,wBAAwB;CACxB,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,UAAU;CACV,YAAY;CACZ,mBAAmB;CACnB,sBAAsB;CACtB,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,sBAAsB;CACtB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,UAAU;CACV,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,UAAU;CACV,eAAe;IACZ,qDAAqD;AACzD;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;CACV,sBAAsB;CACtB,mBAAmB;CACnB,WAAW;CACX,gBAAgB;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;IACI,eAAe;CAClB,kBAAkB;AACnB;;AAEA;IACI;MACE,oEAAoE;MACpE,iBAAiB;MACjB,YAAY;MACZ,WAAW;IACb;IACA;QACI,aAAa;QACb,aAAa;MACf;MACA;QACE,wEAAwE;QACxE,yEAAyE;MAC3E;MACA;QACE,SAAS;MACX;EACJ;;AAEF;IACI;MACE,+DAA+D;MAC/D,iBAAiB;MACjB,YAAY;IACd;IACA;QACI,aAAa;QACb,aAAa;MACf;MACA;QACE,gBAAgB;QAChB,eAAe;QACf,uBAAuB;MACzB;MACA;QACE,wEAAwE;QACxE,yEAAyE;MAC3E;EACJ;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX;EACF;;EAEA;IACE;MACE;IACF;EACF;;EAEA;IACE;MACE,aAAa;IACf;EACF","sourcesContent":["#time-zones-world-map {\r\n    text-align: center;\r\n    font-family: \"Georgia\", serif;\r\n    background-color: #f5f5dc;\r\n    min-height: 100hv;\r\n    /* background-image: url('./images/wooden-table-texture.jpg'); */\r\n    background: linear-gradient(to top, rgba(18, 24, 39, 1), rgba(18, 24, 39, 0) 30%),\r\n    url('./images/wooden-table-texture.jpg');\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    padding: 0;\r\n    margin: 0;\r\n  }\r\n\r\n  .TZTitle {\r\n    font-size: 54px;\r\n    margin-top: 20px;\r\n    margin-bottom: 30px;\r\n    color: #61aea2;\r\n    text-shadow: \r\n      2px 2px 0px #013243, /* Dark shadow for depth */\r\n      4px 4px 0px #028484, /* Mid-tone shadow for gradient effect */\r\n      6px 6px 2px rgba(0, 0, 0, 0.2); /* Light shadow for soft finish */\r\n    font-weight: bold;\r\n    perspective: 100px;\r\n    transform: translateZ(5px);\r\n  }\r\n  \r\n\r\n  .mapbg {\r\n    width: 90%;\r\n    height: 80vh;\r\n    background-image: url('./images/semapCont2.png');\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    padding: 0;\r\n  }\r\n  \r\n  .map-container {\r\n    width: 100%;\r\n    height: 80vh;\r\n    opacity: 0.7;\r\n    filter: grayscale(70%);\r\n    mask-image: radial-gradient(circle, rgba(0, 0, 0, 1) 30%, rgba(0, 0, 0, 0) 90%);\r\n    -webkit-mask-image: radial-gradient(circle, rgba(0, 0, 0, 1) 30%, rgba(0, 0, 0, 0) 90%);\r\n  }\r\n\r\n  .map-label {\r\n    background-color: rgba(255, 255, 255, 0.9);\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n    padding: 5px;\r\n    font-size: 12px;\r\n    line-height: 1.2;\r\n    white-space: nowrap;\r\n    text-align: center;\r\n    transform: translate(-50%, -120%);\r\n    pointer-events: none;\r\n  }\r\n  \r\n  @media (max-width: 768px){\r\n    .mapbg{\r\n        width: 100%;\r\n        padding: 65px 0px;\r\n    }\r\n\r\n    #time-zones-world-map{\r\n      padding: 0px 18px;\r\n    }\r\n    \r\n  }\r\n\r\n.TZcard {\r\n\tcolor: #013243;\r\n\twidth: 300px;\r\n\theight: 400px;\r\n  margin-bottom: 0;\r\n\tbackground: #e0e1dc;\r\n\ttransform-style: preserve-3d;\r\n\ttransform: translate(-190%,-80%) perspective(1000px)rotate(-25deg);\r\n\tbox-shadow: inset 300px 0 50px rgba(0,0,0,.5), 20px 0 60px rgba(0,0,0,.5);\r\n\ttransition: 1.5s;\r\n}\r\n\r\n.TZcard:hover {\r\n\ttransform: translate(-50%,-97%) perspective(2000px) rotate(15deg) scale(1.2);\r\n\tbox-shadow: inset 20px 0 50px rgba(0,0,0,.5), 0 10px 100px rgba(0,0,0,.5);\r\n}\r\n\r\n.TZcard:before {\r\n\tcontent:'';\r\n\twidth: 100%;\r\n\theight: 5px;\r\n\tbackground: #BAC1BA;\r\n\ttransform-origin: bottom;\r\n\ttransform: skewX(-45deg);\r\n}\r\n\r\n.TZcard:after {\r\n\tcontent: '';\r\n\twidth: 5px;\r\n\theight: 100%;\r\n\tbackground: #92A29C;\r\n\ttransform-origin: left;\r\n\ttransform: skewY(-45deg);\r\n}\r\n\r\n.TZcard .TZimgBox {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tposition: relative;\r\n\ttransform-origin: left;\r\n\ttransition: .7s;\r\n}\r\n\r\n.TZcard .TZbark {\r\n\tposition: absolute;\r\n\tbackground: #e0e1dc;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\topacity: 0;\r\n\ttransition: .7s;\r\n}\r\n\r\n.TZcard .TZimgBox img {\r\n\tmin-width: 250px;\r\n\tmax-height: 400px;\r\n}\r\n\r\n.TZcard:hover .TZimgBox {\r\n\ttransform: rotateY(-135deg);\r\n}\r\n\r\n.TZcard:hover .TZbark {\r\n\topacity: 1;\r\n\ttransition: .6s;\r\n    box-shadow: 300px 200px 100px rgba(0, 0, 0, .4) inset;\r\n}\r\n\r\n.TZcard .TZdetails {\r\n\tposition: absolute;\r\n\ttop: -30px;\r\n\tleft: 25px;\r\n\tbox-sizing: border-box;\r\n\tpadding: 0 0 0 10px;\r\n\tz-index: -1;\r\n\tmargin-top: 70px;\r\n  text-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.TZcard .TZdetails p {\r\n\tfont-size: 14px;\r\n\tline-height: 1.5;\r\n}\r\n\r\n.TZcard .TZdetails h4 {\r\n    font-size: 20px;\r\n\ttext-align: center;\r\n}\r\n\r\n@media (max-width: 1335px) {\r\n    .TZcard {\r\n      transform: translate(-105%, -70%) perspective(1000px) rotate(-20deg);\r\n      margin: 10px auto;\r\n      height: auto;\r\n      z-index: 99;\r\n    }\r\n    .TZcard .TZdetails {\r\n        margin-top: 0;\r\n        padding: 20px;\r\n      }\r\n      .TZcard:hover {\r\n        transform: translate(0,-50%) perspective(2000px) rotate(0deg) scale(1.2);\r\n        box-shadow: inset 20px 0 50px rgba(0,0,0,.5), 0 10px 100px rgba(0,0,0,.5);\r\n      }\r\n      .TZcard .TZdetails{\r\n        top: -5px;\r\n      }\r\n  }\r\n\r\n@media (max-width: 768px) {\r\n    .TZcard {\r\n      transform: translate(0%, -35%) perspective(1000px) rotate(0deg);\r\n      margin: 20px auto;\r\n      height: auto;\r\n    }\r\n    .TZcard .TZdetails {\r\n        margin-top: 0;\r\n        padding: 20px;\r\n      }\r\n      .TZcard .TZdetails p {\r\n        line-height: 1.8;\r\n        font-size: 14px;\r\n        transform: rotate(0deg);\r\n      }\r\n      .TZcard:hover {\r\n        transform: translate(0,-35%) perspective(2000px) rotate(0deg) scale(1.2);\r\n        box-shadow: inset 20px 0 50px rgba(0,0,0,.5), 0 10px 100px rgba(0,0,0,.5);\r\n      }\r\n  }\r\n\r\n  .decorate-image {\r\n    position: absolute;\r\n    right:0;\r\n    width: 20%;\r\n    min-width: 200px;\r\n    max-width: 350px;\r\n    height: auto;\r\n    z-index: 10;\r\n    transform: translate(-50%, -80%)\r\n  }\r\n\r\n  @media (max-width: 1335px) {\r\n    .decorate-image{\r\n      transform: translate(-20%, -80%)\r\n    }\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    .decorate-image{\r\n      display: none;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
